import "./App.css"
import InstallationForm from "./pages/InstallationForm"

function App() {
  return <InstallationForm></InstallationForm>
}

export default App
